import { useForm } from 'react-hook-form'; import { ActionButtons } from 'src/components/ui/ActionButtons';
import { parseDateToInput, reverseDate } from 'src/utils/calendarUtils';
import { CalendarMonthRounded as CalendarMonthRoundedIcon } from '@mui/icons-material';
import { getErrorMessage } from 'src/utils/errorHelpers';
import { useState } from 'react';
import { useUpdateDealInformationMutation } from 'src/api/dealApi';
import { ErrorMessage } from 'src/components/errors/ErrorMessage';
import { UpdateDeal } from '../types';

interface Props {
    deal: UpdateDeal;
    onCancel?: () => void;
}

export function EditDealForm({ deal, onCancel }: Props) {
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    const [updateDeal, { isLoading }] = useUpdateDealInformationMutation();

    const {
        register,
        handleSubmit,
        formState: { isDirty },
    } = useForm<Omit<UpdateDeal, "id">>({
        defaultValues: {
            prospectadorId: deal.prospectadorId,
            fechaInicio: parseDateToInput(reverseDate(deal.fechaInicio)),
            fechaFin: parseDateToInput(reverseDate(deal.fechaFin)),
        }
    });

    const handleSubmitForm = handleSubmit(async (data) => {
        try {
            setErrorMessage(null);

            await updateDeal({
                id: deal.id,
                fechaInicio: data.fechaInicio,
                fechaFin: data.fechaFin,
            }).unwrap();

            onCancel?.();
        }
        catch(error) {
            setErrorMessage(getErrorMessage(error));
        }
    });

    return (
        <div>
            <form onSubmit={handleSubmitForm}>
                <div className="flex flex-col gap-y-[11px]">
                    <div className="flex items-center gap-x-2">
                        <div className="flex items-center w-[135px] gap-x-1">
                            <CalendarMonthRoundedIcon sx={{ height: 20, width: 20 }}/>
                            <label className="font-semibold truncate">Fecha de inicio</label>
                        </div>

                        <input
                            {...register("fechaInicio")}
                            type="date"
                            className="
                                rounded-[3px] border-gray-400 border my-1 px-2 flex-1
                                font-semibold text-gray-600 text-sm w-full"/>
                    </div>

                    <div className="flex items-center gap-x-2">
                        <div className="flex items-center w-[135px] gap-x-1">
                            <CalendarMonthRoundedIcon sx={{ height: 20, width: 20 }}/>
                            <label className="font-semibold truncate">Fecha de fin</label>
                        </div>

                        <input
                            {...register("fechaFin")}
                            type="date"
                            className="
                                rounded-[3px] border-gray-400 border my-1 px-2 flex-1
                                font-semibold text-gray-600 text-sm w-full"/>
                    </div>

                    {errorMessage && (
                        <div className="my-2">
                            <ErrorMessage
                            customMessage>
                                <p className="text-sm">{errorMessage}</p>
                            </ErrorMessage>
                        </div>
                    )}

                    <ActionButtons
                        isLoading={isLoading}
                        disabledSaveButton={!isDirty}
                        saveButtonText="Actualizar"
                        saveButtonType="submit"
                        onCancel={onCancel} />
                </div>
            </form>
        </div>
    );
}
